import React, { useCallback } from "react";
import { Grid, Button, Icon, Modal, Header, Input } from "semantic-ui-react";
import { useSelector, useDispatch, connect } from "react-redux";
import { useLocation } from "react-router-dom";

import { socket } from "../../../../lib/socketio";
import { setModel } from "../../../../actions/headerActions";
import Footer from "../../Footer";
import ClearOverride from "../../../Macros/ClearOverride";
import ActivateOverride from "../../../Macros/ActivateOverride";
import {
  Valve,
  Filter,
  FilterTextVertical,
} from "../../../Definitions/GraphicComponents";
import { setCurrentPLC } from "../../../../actions/headerActions";

const TMSOvr_S300_MAIN = ({ model, setModel }) => {
  const [tags, settags] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [anovrdata, setAnOvrdata] = React.useState([]);
  const [digovrdata, setDigOvrdata] = React.useState([]);
  const [tempoverridden, settempoverriden] = React.useState({});
  const [tempovrdata, settempovrdata] = React.useState({});
  const [tempovrdigdata, settempovrdigdata] = React.useState({});
  const [tagdata, settagdata] = React.useState("");
  const [open, setOpen] = React.useState(false);
  const [overrideVisible, setOverrideVisible] = React.useState({
    visible: true,
  });
  const [dataCopy, setDataCopy] = React.useState();
  const [checkdata, setcheckdata] = React.useState("");
  const location = useLocation();
  const currentPLC = useSelector((state) => state.header.currentPLC);
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setCurrentPLC(location.pathname.slice(-4)));
  }, []);

  React.useEffect(() => {
    socket.emit("get tag names", [{ display_id: 5 }, { display_id: 1 }]);
    socket.on("receive tag names", (data) => {
      const isFound = data.tags_data.some(
        (element) => element.display_id === 5,
      );
      if (isFound) {
        settags(data.tags_data);
      }
    });
    return () => {
      socket.removeAllListeners();
    };
  }, [tags]);

  const ids = tags.map((t) => t.id);
  const FooterTags = tags.flatMap((t) => (t.display_id === 1 ? [t] : []));

  const GenTags = tags.flatMap((t) => (t.display_id === 5 ? [t] : []));

  const display = GenTags.map((t) => t.page_name);

  const SysDigTags = GenTags.flatMap((t) =>
    t.name.slice(5, 8) === "DIN" || t.name.slice(5, 9) === "DOUT" ? [t] : [],
  );

  const SysAnTags = GenTags.flatMap((t) =>
    t.name.slice(5, 8) === "AIN" || t.name.slice(5, 9) === "AOUT" ? [t] : [],
  );

  const ClearDigIds = SysDigTags.map((t) => t.id);
  const ClearAnIds = SysAnTags.map((t) => t.id);

  React.useEffect(() => {
    if (ids.length > 0) {
      socket.emit("get tag values", ids);
      socket.on("receive tag values", (value) => {
        setData(value.result);
      });
      return () => {
        socket.removeAllListeners();
      };
    }
  }, [ids, data]);

  React.useEffect(() => {
    let interval = setInterval(setOverrideVisiblity, 400);
    return () => clearInterval(interval);
  }, [overrideVisible]); // eslint-disable-line react-hooks/exhaustive-deps

  const tmstags = [];
  let rows;
  const length = GenTags.length;
  rows = Math.round(length / 3);
  let i = 0;
  while (i < length) {
    tmstags.push(GenTags.slice(i, i + rows));
    i += rows;
  }

  const parentcallbackAn = useCallback((flag) => {
    if (flag === true) {
      setAnOvrdata([]);
      // setIsCopied(false);
      settags([]);
      settags([]);
    }
  }, []);

  const parentcallbackDig = useCallback((flag) => {
    if (flag === true) {
      setDigOvrdata([]);
      // setIsCopied(false);
      settags([]);
      setDataCopy({});
    }
  }, []);

  const getDigVal = (value, name) => {
    if (typeof value === "undefined") {
      return "";
    }
    if (
      name === "CV451" ||
      name === "CV560" ||
      name === "CV012" ||
      name === "CV014" ||
      name === "CV105" ||
      name === "CV140" ||
      name === "CV380" ||
      name === "CV511" ||
      name === "CV150" ||
      name === "CV510" ||
      name === "CV720" ||
      name === "ZS014" ||
      name === "CV710" ||
      name === "CV030" ||
      name === "CV031" ||
      name === "CV140" ||
      name === "CV020_STATUS" ||
      name === "CV011" ||
      name === "CV021" ||
      name === "CV022" ||
      name === "CV400" ||
      name === "CV401" ||
      name === "CV711" ||
      name === "CV713"
    ) {
      if (name === "CV720" || name === "CV710" || name === "CV713") {
        if (value === 0) {
          return "OPEN";
        } else return "CLOSED";
      } else {
        if (value === 0) {
          return "CLOSED";
        } else return "OPEN";
      }
    } else {
      if (value === 0) {
        return "OFF";
      } else return "ON";
    }
  };

  const setOverrideVisiblity = () => {
    setOverrideVisible({
      ...overrideVisible,
      visible: !overrideVisible.visible,
    });
  };

  const handleCheck = (event, obj_key) => {
    if (event.target.id === "1") {
      if (
        obj_key === 10170 ||
        obj_key === 10231 ||
        obj_key === 12157 ||
        obj_key === 20170 ||
        obj_key === 20231 ||
        obj_key === 22157 ||
        obj_key === 30170 ||
        obj_key === 30231 ||
        obj_key === 32157 ||
        obj_key === 40170 ||
        obj_key === 40231 ||
        obj_key === 42157 ||
        obj_key === 50170 ||
        obj_key === 50231 ||
        obj_key === 52157
      ) {
        setcheckdata(0);
        setDataCopy({ ...dataCopy, [obj_key]: 0 });
      } else {
        setcheckdata(1);
        setDataCopy({ ...dataCopy, [obj_key]: 1 });
      }
    } else if (event.target.id === "0") {
      if (
        obj_key === 10170 ||
        obj_key === 10231 ||
        obj_key === 12157 ||
        obj_key === 20170 ||
        obj_key === 20231 ||
        obj_key === 22157 ||
        obj_key === 30170 ||
        obj_key === 30231 ||
        obj_key === 32157 ||
        obj_key === 40170 ||
        obj_key === 40231 ||
        obj_key === 42157 ||
        obj_key === 50170 ||
        obj_key === 50231 ||
        obj_key === 52157
      ) {
        setcheckdata(1);
        setDataCopy({ ...dataCopy, [obj_key]: 1 });
      } else {
        setcheckdata(0);
        setDataCopy({ ...dataCopy, [obj_key]: 0 });
      }
    }
  };

  const handleChange = (e, { value }) => {
    settagdata(e.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
  };

  const handleOpen = (id) => {
    setOpen({ ...open, [id]: true });
  };

  const handleClose = (id) => {
    settagdata("");
    if (typeof dataCopy !== "undefined" && id in dataCopy) {
      delete dataCopy[id];
    }
    setcheckdata("");
    setOpen({ ...open, [id]: false });
  };

  const handleToggle = (event, id) => {
    event.preventDefault();
    var datavalue;
    if (typeof tagdata === "undefined" || tagdata === "") {
      datavalue = data[id];
    } else datavalue = tagdata;
    var writedata = { tag_id: id, tag_value: datavalue, isOverriden: 1 };
    settempovrdata({ ...tempovrdata, [id]: datavalue });
    settempoverriden({ ...tempoverridden, [id]: 1 });
    var index = anovrdata.findIndex((x) => x.tag_id === id);
    if (typeof anovrdata[index] === "undefined") {
      anovrdata.push(writedata);
    } else {
      anovrdata[index] = { tag_id: id, tag_value: datavalue, isOverriden: 1 };
    }
    setOpen({ ...open, [id]: false });
    settagdata("");
  };

  const handleDigToggle = (event, id) => {
    event.preventDefault();
    var boolvalue;
    if (typeof checkdata === "undefined" || checkdata === "") {
      boolvalue = data[id];
    } else {
      boolvalue = checkdata;
    }
    if (id === 97792 || id === 97800) {
      var writedata1 = { tag_id: 97792, tag_value: boolvalue, isOverriden: 1 };
      var writedata2 = { tag_id: 97800, tag_value: boolvalue, isOverriden: 1 };
      var index1 = digovrdata.findIndex((x) => x.tag_id === 97792);
      var index2 = digovrdata.findIndex((x) => x.tag_id === 97800);
      if (
        typeof digovrdata[index1] === "undefined" &&
        typeof digovrdata[index2] === "undefined"
      ) {
        digovrdata.push(writedata1, writedata2);
      } else {
        digovrdata[index1] = {
          tag_id: 97792,
          tag_value: boolvalue,
          isOverriden: 1,
        };
        digovrdata[index2] = {
          tag_id: 97800,
          tag_value: boolvalue,
          isOverriden: 1,
        };
      }
      settempovrdigdata({
        ...tempovrdigdata,
        97792: boolvalue,
        97800: boolvalue,
      });
      settempoverriden({ ...tempoverridden, 97792: 1, 97800: 1 });
    } else {
      var writedata = { tag_id: id, tag_value: boolvalue, isOverriden: 1 };
      var index = digovrdata.findIndex((x) => x.tag_id === id);
      if (typeof digovrdata[index] === "undefined") {
        digovrdata.push(writedata);
      } else {
        digovrdata[index] = {
          tag_id: id,
          tag_value: boolvalue,
          isOverriden: 1,
        };
      }
      settempoverriden({ ...tempoverridden, [id]: 1 });
      settempovrdigdata({ ...tempovrdigdata, [id]: boolvalue });
    }
    setOpen({ ...open, [id]: false });
    setcheckdata("");
  };

  const handleClear = (event, id) => {
    event.preventDefault();
    var adiodata = {
      buttonClickType: "Clear Individual Analog Overrides",
      tags: [id],
    };
    socket.emit("button click", adiodata);
    delete tempovrdata[id];
    delete tempoverridden[id];
    setOpen({ ...open, [id]: false });
    var index = anovrdata.findIndex((x) => x.tag_id === id);
    if (index >= 0) {
      anovrdata.splice(index, 1);
    }
    var col_idx = tags.findIndex((x) => x.id === id);
    tags[col_idx].isOverriden = 0;
  };

  const handleDigClear = (event, id) => {
    event.preventDefault();
    if (id === 97792 || id === 97800) {
      var adiodata = {
        buttonClickType: "Clear Individual Digital Overrides",
        tags: [97792, 97800],
      };
      socket.emit("button click", adiodata);
      setOpen({ ...open, [id]: false });
      delete tempovrdigdata[97792];
      delete tempovrdigdata[97800];
      delete tempoverridden[97792];
      delete tempoverridden[97800];
      if (
        typeof dataCopy !== "undefined" &&
        (97792 in dataCopy || 97800 in dataCopy)
      ) {
        delete dataCopy[97792];
        delete dataCopy[97800];
      }
      var index1 = digovrdata.findIndex((x) => x.tag_id === 97792);
      var index2 = digovrdata.findIndex((x) => x.tag_id === 97800);
      var idsToRemove = [index1, index2];
      for (let j = idsToRemove.length - 1; j >= 0; j--) {
        digovrdata.splice(idsToRemove[j], 1);
      }
      var col_idx1 = tags.findIndex((x) => x.id === 97792);
      var col_idx2 = tags.findIndex((x) => x.id === 97800);
      tags[col_idx1].isOverriden = 0;
      tags[col_idx2].isOverriden = 0;
      // setIsCopied(false);
    } else {
      var adiodata = {
        buttonClickType: "Clear Individual Digital Overrides",
        tags: [id],
      };
      socket.emit("button click", adiodata);
      setOpen({ ...open, [id]: false });
      delete tempovrdigdata[id];
      delete tempoverridden[id];
      if (typeof dataCopy !== "undefined" && id in dataCopy) {
        delete dataCopy[id];
      }
      var index = digovrdata.findIndex((x) => x.tag_id === id);
      if (index >= 0) {
        digovrdata.splice(index, 1);
      }
      var col_idx = tags.findIndex((x) => x.id === id);
      tags[col_idx].isOverriden = 0;
      // setIsCopied(false);
    }
  };

  const CheckOnOp = (name) => {
    if (
      name === "IORack5Status" ||
      name === "IORack6Status" ||
      name === "LOI Shutdown" ||
      name === "LOR Enable" ||
      name === "Cust Norm SD"
    ) {
      return "SD";
    } else if (name === "GFD_Bender") {
      return "FAULT";
    } else if (
      name === "CV451" ||
      name === "CV560" ||
      name === "CV012" ||
      name === "CV014" ||
      name === "CV105" ||
      name === "CV140" ||
      name === "CV380" ||
      name === "CV511" ||
      name === "CV150" ||
      name === "CV510" ||
      name === "CV720" ||
      name === "ZS014" ||
      name === "CV710" ||
      name === "CV030" ||
      name === "CV031" ||
      name === "CV140" ||
      name === "CV020_STATUS" ||
      name === "CV011" ||
      name === "CV021" ||
      name === "CV022" ||
      name === "CV400" ||
      name === "CV401" ||
      name === "CV711" ||
      name === "CV713"
    ) {
      return "OPEN";
    } else {
      return "ON";
    }
  };

  const CheckOffOp = (name) => {
    if (
      name === "IORack5Status" ||
      name === "IORack6Status" ||
      name === "LOI Shutdown" ||
      name === "LOR Enable" ||
      name === "Cust Norm SD" ||
      name === "GFD_Bender"
    ) {
      return "OK";
    } else if (
      name === "CV451" ||
      name === "CV560" ||
      name === "CV012" ||
      name === "CV014" ||
      name === "CV105" ||
      name === "CV140" ||
      name === "CV380" ||
      name === "CV511" ||
      name === "CV150" ||
      name === "CV510" ||
      name === "CV720" ||
      name === "ZS014" ||
      name === "CV710" ||
      name === "CV030" ||
      name === "CV031" ||
      name === "CV140" ||
      name === "CV020_STATUS" ||
      name === "CV011" ||
      name === "CV021" ||
      name === "CV022" ||
      name === "CV400" ||
      name === "CV401" ||
      name === "CV711" ||
      name === "CV713"
    ) {
      return "CLOSED";
    } else {
      return "OFF";
    }
  };

  const getCheckEnable = (id) => {
    if (typeof dataCopy !== "undefined" && id in dataCopy) {
      if (
        id === 20170 ||
        id === 20231 ||
        id === 12157 ||
        id === 20170 ||
        id === 20231 ||
        id === 22157 ||
        id === 30170 ||
        id === 30231 ||
        id === 32157 ||
        id === 40170 ||
        id === 40231 ||
        id === 42157 ||
        id === 50170 ||
        id === 50231 ||
        id === 52157
      ) {
        // CV710, CV720
        return dataCopy[id] === 0;
      } else {
        return dataCopy[id] === 1;
      }
    } else {
      if (
        id === 20170 ||
        id === 20231 ||
        id === 12157 ||
        id === 20170 ||
        id === 20231 ||
        id === 22157 ||
        id === 30170 ||
        id === 30231 ||
        id === 32157 ||
        id === 40170 ||
        id === 40231 ||
        id === 42157 ||
        id === 50170 ||
        id === 50231 ||
        id === 52157
      ) {
        // CV710, CV720
        return data[id] === 0;
      } else {
        return data[id] === 1;
      }
    }
    // return false;
  };

  const getCheckDisable = (id) => {
    if (typeof dataCopy !== "undefined" && id in dataCopy) {
      if (
        id === 20170 ||
        id === 20231 ||
        id === 12157 ||
        id === 20170 ||
        id === 20231 ||
        id === 22157 ||
        id === 30170 ||
        id === 30231 ||
        id === 32157 ||
        id === 40170 ||
        id === 40231 ||
        id === 42157 ||
        id === 50170 ||
        id === 50231 ||
        id === 52157
      ) {
        return dataCopy[id] === 1;
      } else {
        return dataCopy[id] === 0;
      }
    } else {
      if (
        id === 20170 ||
        id === 20231 ||
        id === 12157 ||
        id === 20170 ||
        id === 20231 ||
        id === 22157 ||
        id === 30170 ||
        id === 30231 ||
        id === 32157 ||
        id === 40170 ||
        id === 40231 ||
        id === 42157 ||
        id === 50170 ||
        id === 50231 ||
        id === 52157
      ) {
        return data[id] === 1;
      } else {
        return data[id] === 0;
      }
    }
  };

  const grid = (tag_id) => (
    <Grid stretched style={{ height: "100%", width: "200px" }}>
      <Grid.Row style={{ marginBottom: "0px", paddingBottom: "0px" }}>
        <Grid.Column width={5} style={styles.name}>
          {typeof data !== "undefined" &&
          data !== null &&
          typeof data[tag_id] !== "undefined"
            ? tag_id === 22
              ? data[tag_id].toFixed(3)
              : data[tag_id].toFixed(2)
            : ""}
        </Grid.Column>
        <Grid.Column width={7} style={styles.gridUnit}>
          {typeof tags !== "undefined" &&
          tags !== null &&
          tags.length > 0 &&
          tags.findIndex((x) => x.id === tag_id) !== -1
            ? tag_id === 9999 || tag_id === 9998
              ? "SP"
              : tags[tags.findIndex((x) => x.id === tag_id)].unit
            : ""}
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{ paddingTop: "0px", marginTop: "0px" }}>
        <Grid.Column
          style={{
            color: "grey",
            fontSize: "18px",
            fontWeight: "bold",
            marginTop: "0px",
            paddingTop: "0px",
          }}
        >
          {typeof tags !== "undefined" &&
          tags !== null &&
          tags.length > 0 &&
          tags.findIndex((x) => x.id === tag_id) !== -1
            ? tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name
            : ""}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );

  const grid_no_label = (tag_id) => (
    <Grid stretched style={{ height: "100%" }}>
      <Grid.Row style={{ marginBottom: "0px", paddingBottom: "0px" }}>
        <Grid.Column width={8} style={styles.name}>
          {typeof data !== "undefined" &&
          data !== null &&
          typeof data[tag_id] !== "undefined"
            ? tag_id === 22
              ? data[tag_id].toFixed(3)
              : data[tag_id].toFixed(2)
            : ""}
        </Grid.Column>
        <Grid.Column style={styles.unit}>
          {typeof tags !== "undefined" &&
          tags !== null &&
          tags.length > 0 &&
          tags.findIndex((x) => x.id === tag_id) !== -1
            ? tag_id === 9999
              ? "SP"
              : tags[tags.findIndex((x) => x.id === tag_id)].unit
            : ""}
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );

  const grid_digital = (tag_id) =>
    typeof tags !== "undefined" &&
    tags !== null &&
    tags.length > 0 &&
    tags.findIndex((x) => x.id === tag_id) !== -1 &&
    typeof data !== "undefined" ? (
      <Grid>
        <Grid.Row
          style={{
            paddingBottom: "0px",
            marginBottom: "0px",
            paddingLeft: "10px",
          }}
        >
          <Grid.Column
            style={{
              color: "#f5c71a",
              paddingTop: "0",
              fontSize: "16px",
            }}
          >
            {" "}
            {getDigVal(
              tempovrdigdata[tag_id],
              tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name,
            )}
            {(typeof tempoverridden !== "undefined" &&
              typeof tempoverridden[tag_id] !== "undefined" &&
              tempoverridden[tag_id] === 1 &&
              overrideVisible.visible &&
              tags[tags.findIndex((x) => x.id === tag_id)].isOverriden !== 1) ||
            (tags[tags.findIndex((x) => x.id === tag_id)].isOverriden === 1 &&
              overrideVisible.visible) ? (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="yellow"
                size="small"
              />
            ) : (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="black"
                size="small"
              />
            )}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={styles.row}>
          <Grid.Column style={{ paddingTop: "0px" }}>
            <Button
              key="button"
              type="button"
              inverted
              color="grey"
              size="tiny"
              compact
              style={styles.textwrap}
              content={
                tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name
              }
              onClick={() => {
                setOpen({ ...open, [tag_id]: true });
              }}
            />
            <Modal
              key={tag_id}
              style={styles.width}
              open={open[tag_id]}
              onClose={handleClose[tag_id]}
              onOpen={handleOpen[tag_id]}
            >
              <Modal.Header>Digital Override </Modal.Header>
              <Modal.Description>
                <Header style={styles.header}>
                  Enter Value for{" "}
                  {
                    tags[tags.findIndex((x) => x.id === tag_id)]
                      .tag_display_name
                  }{" "}
                </Header>
              </Modal.Description>
              <Modal.Content>
                <Button.Group toggle>
                  <Button
                    size="medium"
                    id={1}
                    active={getCheckEnable(tag_id)}
                    onClick={(event, value) => handleCheck(event, tag_id)}
                    content={CheckOnOp(
                      tags[tags.findIndex((x) => x.id === tag_id)]
                        .tag_display_name,
                    )}
                  />
                  <Button
                    size="medium"
                    id={0}
                    active={getCheckDisable(tag_id)}
                    onClick={(event, value) => handleCheck(event, tag_id)}
                    content={CheckOffOp(
                      tags[tags.findIndex((x) => x.id === tag_id)]
                        .tag_display_name,
                    )}
                  />
                </Button.Group>
                <Button
                  style={{ marginTop: "10px" }}
                  color="blue"
                  content={"Clear Overrides"}
                  onClick={(event, value) => handleDigClear(event, tag_id)}
                />
              </Modal.Content>
              <Modal.Actions style={styles.toggle}>
                <Button
                  color="blue"
                  content={"Ok"}
                  onClick={(event, value) => handleDigToggle(event, tag_id)}
                />
                <Button
                  color="red"
                  content={"Cancel"}
                  onClick={() => handleClose(tag_id)}
                />
              </Modal.Actions>
            </Modal>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    ) : (
      ""
    );

  const grid_analog = (tag_id) =>
    typeof tags !== "undefined" &&
    tags !== null &&
    tags.length > 0 &&
    tags.findIndex((x) => x.id === tag_id) !== -1 &&
    typeof data !== "undefined" ? (
      <Grid>
        <Grid.Row
          style={{
            paddingBottom: "0px",
            marginBottom: "0px",
            paddingLeft: "10px",
          }}
        >
          <Grid.Column
            style={{ color: "#f5c71a", paddingTop: "0", fontSize: "16px" }}
          >
            {" "}
            {tempovrdata[tag_id]}
            {(typeof tempoverridden !== "undefined" &&
              typeof tempoverridden[tag_id] !== "undefined" &&
              tempoverridden[tag_id] === 1 &&
              overrideVisible.visible &&
              tags[tags.findIndex((x) => x.id === tag_id)].isOverriden !== 1) ||
            (tags[tags.findIndex((x) => x.id === tag_id)].isOverriden === 1 &&
              overrideVisible.visible) ? (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="yellow"
                size="small"
              />
            ) : (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="black"
                size="small"
              />
            )}
          </Grid.Column>
        </Grid.Row>

        <Grid.Row style={styles.row}>
          <Grid.Column width="6" style={{ paddingTop: "0px" }}>
            <Button
              key="button"
              type="button"
              compact
              inverted
              color="grey"
              size="tiny"
              content={
                typeof data[tag_id] !== "undefined"
                  ? tag_id === 22
                    ? Math.round(data[tag_id] * 1000) / 1000
                    : Math.round(data[tag_id] * 100) / 100
                  : ""
              }
              // content={Math.round(data[r.id]*100)/100}
              onClick={() => {
                setOpen({ ...open, [tag_id]: true });
              }}
            />
            <Modal
              key={tag_id}
              style={styles.width}
              open={open[tag_id]}
              onClose={handleClose[tag_id]}
              onOpen={handleOpen[tag_id]}
            >
              <Modal.Header>Analog Override </Modal.Header>
              <Modal.Description>
                <Header style={styles.header}>
                  Enter Value for{" "}
                  {
                    tags[tags.findIndex((x) => x.id === tag_id)]
                      .tag_display_name
                  }{" "}
                </Header>
              </Modal.Description>
              <Modal.Content>
                <form autoComplete="off" onSubmit={handleSubmit}>
                  <Input
                    focus
                    autoFocus
                    placeholder="Value"
                    style={styles.input}
                    name="Input change"
                    label={
                      tags[tags.findIndex((x) => x.id === tag_id)].unit || ""
                    }
                    labelPosition="right"
                    type="number"
                    step="0.00001"
                    size="small"
                    min={tags[tags.findIndex((x) => x.id === tag_id)].min}
                    max={tags[tags.findIndex((x) => x.id === tag_id)].max}
                    onChange={(event, value) => handleChange(event, value)}
                    defaultValue={data[tag_id]}
                  />
                </form>
                <Button
                  style={{ marginTop: "10px" }}
                  color="blue"
                  content={"Clear Overrides"}
                  onClick={(event, value) => handleClear(event, tag_id)}
                />
              </Modal.Content>
              <Modal.Actions>
                <Button
                  color="blue"
                  content={"Ok"}
                  onClick={(event, value) => handleToggle(event, tag_id)}
                />
                <Button
                  color="red"
                  content={"Cancel"}
                  onClick={() => handleClose(tag_id)}
                />
              </Modal.Actions>
            </Modal>
          </Grid.Column>

          <Grid.Column style={styles.unit}>
            {tags[tags.findIndex((x) => x.id === tag_id)].unit}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ paddingTop: "4px", marginTop: "0px" }}>
          <Grid.Column
            style={{
              color: "#fff",
              fontSize: "16px",
              fontWeight: "bold",
              marginLeft: "5px",
              marginTop: "0px",
              paddingTop: "0px",
            }}
          >
            {typeof tags !== "undefined" &&
            tags !== null &&
            tags.length > 0 &&
            tags.findIndex((x) => x.id === tag_id) !== -1
              ? tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name
              : ""}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    ) : (
      ""
    );

  const grid_analog_reverse = (tag_id) =>
    typeof tags !== "undefined" &&
    tags !== null &&
    tags.length > 0 &&
    tags.findIndex((x) => x.id === tag_id) !== -1 &&
    typeof data !== "undefined" ? (
      <Grid>
        <Grid.Row style={{ paddingBottom: "4px", marginBottom: "0px" }}>
          <Grid.Column
            style={{
              color: "#fff",
              fontSize: "16px",
              fontWeight: "bold",
              marginLeft: "5px",
              marginTop: "0px",
              paddingTop: "0px",
            }}
          >
            {typeof tags !== "undefined" &&
            tags !== null &&
            tags.length > 0 &&
            tags.findIndex((x) => x.id === tag_id) !== -1
              ? tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name
              : ""}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row
          style={{
            paddingTop: "0px",
            marginTop: "0px",
            maxWidth: "800px",
            paddingBottom: "0px",
            marginBottom: "0px",
          }}
        >
          <Grid.Column width="6" style={{ paddingTop: "0px" }}>
            <Button
              key="button"
              type="button"
              compact
              inverted
              color="grey"
              size="tiny"
              content={
                typeof data[tag_id] !== "undefined"
                  ? tag_id === 22
                    ? Math.round(data[tag_id] * 1000) / 1000
                    : Math.round(data[tag_id] * 100) / 100
                  : ""
              }
              // content={Math.round(data[r.id]*100)/100}
              onClick={() => {
                setOpen({ ...open, [tag_id]: true });
              }}
            />
            <Modal
              key={tag_id}
              style={styles.width}
              open={open[tag_id]}
              onClose={handleClose[tag_id]}
              onOpen={handleOpen[tag_id]}
            >
              <Modal.Header>Analog Override </Modal.Header>
              <Modal.Description>
                <Header style={styles.header}>
                  Enter Value for{" "}
                  {
                    tags[tags.findIndex((x) => x.id === tag_id)]
                      .tag_display_name
                  }{" "}
                </Header>
              </Modal.Description>
              <Modal.Content>
                <form autoComplete="off" onSubmit={handleSubmit}>
                  <Input
                    focus
                    autoFocus
                    placeholder="Value"
                    style={styles.input}
                    name="Input change"
                    label={
                      tags[tags.findIndex((x) => x.id === tag_id)].unit || ""
                    }
                    labelPosition="right"
                    type="number"
                    step="0.00001"
                    size="small"
                    min={tags[tags.findIndex((x) => x.id === tag_id)].min}
                    max={tags[tags.findIndex((x) => x.id === tag_id)].max}
                    onChange={(event, value) => handleChange(event, value)}
                    defaultValue={data[tag_id]}
                  />
                </form>
                <Button
                  style={{ marginTop: "10px" }}
                  color="blue"
                  content={"Clear Overrides"}
                  onClick={(event, value) => handleClear(event, tag_id)}
                />
              </Modal.Content>
              <Modal.Actions>
                <Button
                  color="blue"
                  content={"Ok"}
                  onClick={(event, value) => handleToggle(event, tag_id)}
                />
                <Button
                  color="red"
                  content={"Cancel"}
                  onClick={() => handleClose(tag_id)}
                />
              </Modal.Actions>
            </Modal>
          </Grid.Column>

          <Grid.Column style={styles.unit}>
            {tags[tags.findIndex((x) => x.id === tag_id)].unit}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row
          style={{
            paddingBottom: "0px",
            marginBottom: "0px",
            paddingTop: "0px",
            marginTop: "0px",
            paddingLeft: "10px",
          }}
        >
          <Grid.Column
            style={{ color: "#f5c71a", paddingTop: "0", fontSize: "16px" }}
          >
            {" "}
            {tempovrdata[tag_id]}
            {(typeof tempoverridden !== "undefined" &&
              typeof tempoverridden[tag_id] !== "undefined" &&
              tempoverridden[tag_id] === 1 &&
              overrideVisible.visible &&
              tags[tags.findIndex((x) => x.id === tag_id)].isOverriden !== 1) ||
            (tags[tags.findIndex((x) => x.id === tag_id)].isOverriden === 1 &&
              overrideVisible.visible) ? (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="yellow"
                size="small"
              />
            ) : (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="black"
                size="small"
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    ) : (
      ""
    );

  const grid_digital_reverse = (tag_id) =>
    typeof tags !== "undefined" &&
    tags !== null &&
    tags.length > 0 &&
    tags.findIndex((x) => x.id === tag_id) !== -1 &&
    typeof data !== "undefined" ? (
      <Grid>
        <Grid.Row
          style={{
            maxWidth: "800px",
            paddingBottom: "0px",
            marginBottom: "0px",
          }}
        >
          <Grid.Column style={{ paddingTop: "0px" }}>
            <Button
              key="button"
              type="button"
              color="grey"
              size="tiny"
              inverted
              compact
              style={styles.textwrap}
              content={
                tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name
              }
              onClick={() => {
                setOpen({ ...open, [tag_id]: true });
              }}
            />
            <Modal
              key={tag_id}
              style={styles.width}
              open={open[tag_id]}
              onClose={handleClose[tag_id]}
              onOpen={handleOpen[tag_id]}
            >
              <Modal.Header>Digital Override </Modal.Header>
              <Modal.Description>
                <Header style={styles.header}>
                  Enter Value for{" "}
                  {
                    tags[tags.findIndex((x) => x.id === tag_id)]
                      .tag_display_name
                  }{" "}
                </Header>
              </Modal.Description>
              <Modal.Content>
                <Button.Group toggle>
                  <Button
                    size="medium"
                    id={1}
                    active={getCheckEnable(tag_id)}
                    onClick={(event, value) => handleCheck(event, tag_id)}
                    content={CheckOnOp(
                      tags[tags.findIndex((x) => x.id === tag_id)]
                        .tag_display_name,
                    )}
                  />
                  <Button
                    size="medium"
                    id={0}
                    active={getCheckDisable(tag_id)}
                    onClick={(event, value) => handleCheck(event, tag_id)}
                    content={CheckOffOp(
                      tags[tags.findIndex((x) => x.id === tag_id)]
                        .tag_display_name,
                    )}
                  />
                </Button.Group>
                <Button
                  style={{ marginTop: "10px" }}
                  color="blue"
                  content={"Clear Overrides"}
                  onClick={(event, value) => handleDigClear(event, tag_id)}
                />
              </Modal.Content>
              <Modal.Actions style={styles.toggle}>
                <Button
                  color="blue"
                  content={"Ok"}
                  onClick={(event, value) => handleDigToggle(event, tag_id)}
                />
                <Button
                  color="red"
                  content={"Cancel"}
                  onClick={() => handleClose(tag_id)}
                />
              </Modal.Actions>
            </Modal>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row
          style={{ paddingTop: "0px", marginTop: "0px", paddingLeft: "10px" }}
        >
          <Grid.Column
            style={{
              color: "#f5c71a",
              paddingTop: "0",
              fontSize: "16px",
            }}
          >
            {" "}
            {getDigVal(
              tempovrdigdata[tag_id],
              tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name,
            )}
            {(typeof tempoverridden !== "undefined" &&
              typeof tempoverridden[tag_id] !== "undefined" &&
              tempoverridden[tag_id] === 1 &&
              overrideVisible.visible &&
              tags[tags.findIndex((x) => x.id === tag_id)].isOverriden !== 1) ||
            (tags[tags.findIndex((x) => x.id === tag_id)].isOverriden === 1 &&
              overrideVisible.visible) ? (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="yellow"
                size="small"
              />
            ) : (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="black"
                size="small"
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    ) : (
      ""
    );

  const grid_digital_side = (tag_id, label) =>
    typeof tags !== "undefined" &&
    tags !== null &&
    tags.length > 0 &&
    tags.findIndex((x) => x.id === tag_id) !== -1 &&
    typeof data !== "undefined" ? (
      <Grid>
        <Grid.Row key={tag_id}>
          <Grid.Column width="1">{label === "" ? "" : label}</Grid.Column>
          <Grid.Column width="5">
            <Button
              key="button"
              type="button"
              inverted
              color={
                typeof data[tag_id] === "undefined"
                  ? "grey"
                  : tag_id === 97788 || tag_id === 97804
                    ? data[tag_id] === 1
                      ? "red"
                      : "green"
                    : data[tag_id] === 1
                      ? "green"
                      : "red"
              }
              size="tiny"
              compact
              content={
                typeof data[tag_id] === "undefined"
                  ? ""
                  : getDigVal(
                      data[tag_id],
                      tags[tags.findIndex((x) => x.id === tag_id)]
                        .tag_display_name,
                    )
              }
              onClick={() => {
                setOpen({ ...open, [tag_id]: true });
              }}
            />
            <Modal
              key={tag_id}
              style={styles.width}
              open={open[tag_id]}
              onClose={handleClose[tag_id]}
              onOpen={handleOpen[tag_id]}
            >
              <Modal.Header>Digital Override</Modal.Header>
              <Modal.Description>
                <Header style={styles.header}>
                  Enter Value for{" "}
                  {
                    tags[tags.findIndex((x) => x.id === tag_id)]
                      .tag_display_name
                  }{" "}
                </Header>
              </Modal.Description>
              <Modal.Content>
                <Button.Group toggle>
                  <Button
                    size="medium"
                    id={1}
                    active={getCheckEnable(tag_id)}
                    onClick={(event, value) => handleCheck(event, tag_id)}
                    content={CheckOnOp(
                      tags[tags.findIndex((x) => x.id === tag_id)]
                        .tag_display_name,
                    )}
                  />
                  <Button
                    size="medium"
                    id={0}
                    active={getCheckDisable(tag_id)}
                    onClick={(event, value) => handleCheck(event, tag_id)}
                    content={CheckOffOp(
                      tags[tags.findIndex((x) => x.id === tag_id)]
                        .tag_display_name,
                    )}
                  />
                </Button.Group>
                <Button
                  style={{ marginTop: "10px" }}
                  color="blue"
                  content={"Clear Overrides"}
                  onClick={(event, value) => handleDigClear(event, tag_id)}
                />
              </Modal.Content>
              <Modal.Actions style={styles.toggle}>
                <Button
                  color="blue"
                  content={"Ok"}
                  onClick={(event, value) => handleDigToggle(event, tag_id)}
                />
                <Button
                  color="red"
                  content={"Cancel"}
                  onClick={() => handleClose(tag_id)}
                />
              </Modal.Actions>
            </Modal>
          </Grid.Column>
          <Grid.Column
            width="8"
            style={{ color: "#f5c71a", marginLeft: "2px" }}
          >
            {" "}
            {getDigVal(
              tempovrdigdata[tag_id],
              tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name,
            )}
            {(typeof tempoverridden !== "undefined" &&
              typeof tempoverridden[tag_id] !== "undefined" &&
              tempoverridden[tag_id] === 1 &&
              overrideVisible.visible &&
              tags[tags.findIndex((x) => x.id === tag_id)].isOverriden !== 1) ||
            (tags[tags.findIndex((x) => x.id === tag_id)].isOverriden === 1 &&
              overrideVisible.visible) ? (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="yellow"
                size="small"
              />
            ) : (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="black"
                size="small"
              />
            )}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    ) : (
      ""
    );

  const grid_digital_value = (tag_id) =>
    typeof tags !== "undefined" &&
    tags !== null &&
    tags.length > 0 &&
    tags.findIndex((x) => x.id === tag_id) !== -1 &&
    typeof data !== "undefined" ? (
      <Grid>
        <Grid.Row
          style={{
            paddingBottom: "0px",
            marginBottom: "0px",
            paddingLeft: "10px",
          }}
        >
          <Grid.Column
            style={{
              color: "#f5c71a",
              paddingTop: "0",
              fontSize: "16px",
            }}
          >
            {" "}
            {getDigVal(
              tempovrdigdata[tag_id],
              tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name,
            )}
            {(typeof tempoverridden !== "undefined" &&
              typeof tempoverridden[tag_id] !== "undefined" &&
              tempoverridden[tag_id] === 1 &&
              overrideVisible.visible &&
              tags[tags.findIndex((x) => x.id === tag_id)].isOverriden !== 1) ||
            (tags[tags.findIndex((x) => x.id === tag_id)].isOverriden === 1 &&
              overrideVisible.visible) ? (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="yellow"
                size="small"
              />
            ) : (
              <Icon
                style={styles.overriden}
                name="asterisk"
                color="black"
                size="small"
              />
            )}
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={styles.row}>
          <Grid.Column style={{ paddingTop: "0px" }}>
            <Button
              key="button"
              type="button"
              color="grey"
              size="tiny"
              inverted
              compact
              style={styles.textwrap}
              content={
                typeof data[tag_id] === "undefined"
                  ? ""
                  : getDigVal(
                      data[tag_id],
                      tags[tags.findIndex((x) => x.id === tag_id)]
                        .tag_display_name,
                    )
              }
              onClick={() => {
                setOpen({ ...open, [tag_id]: true });
              }}
            />
            <Modal
              key={tag_id}
              style={styles.width}
              open={open[tag_id]}
              onClose={handleClose[tag_id]}
              onOpen={handleOpen[tag_id]}
            >
              <Modal.Header>Digital Override </Modal.Header>
              <Modal.Description>
                <Header style={styles.header}>
                  Enter Value for{" "}
                  {
                    tags[tags.findIndex((x) => x.id === tag_id)]
                      .tag_display_name
                  }{" "}
                </Header>
              </Modal.Description>
              <Modal.Content>
                <Button.Group toggle>
                  <Button
                    size="medium"
                    id={1}
                    active={getCheckEnable(tag_id)}
                    onClick={(event, value) => handleCheck(event, tag_id)}
                    content={CheckOnOp(
                      tags[tags.findIndex((x) => x.id === tag_id)]
                        .tag_display_name,
                    )}
                  />
                  <Button
                    size="medium"
                    id={0}
                    active={getCheckDisable(tag_id)}
                    onClick={(event, value) => handleCheck(event, tag_id)}
                    content={CheckOffOp(
                      tags[tags.findIndex((x) => x.id === tag_id)]
                        .tag_display_name,
                    )}
                  />
                </Button.Group>
                <Button
                  style={{ marginTop: "10px" }}
                  color="blue"
                  content={"Clear Overrides"}
                  onClick={(event, value) => handleDigClear(event, tag_id)}
                />
              </Modal.Content>
              <Modal.Actions style={styles.toggle}>
                <Button
                  color="blue"
                  content={"Ok"}
                  onClick={(event, value) => handleDigToggle(event, tag_id)}
                />
                <Button
                  color="red"
                  content={"Cancel"}
                  onClick={() => handleClose(tag_id)}
                />
              </Modal.Actions>
            </Modal>
          </Grid.Column>
        </Grid.Row>
        <Grid.Row style={{ paddingTop: "4px", marginTop: "0px" }}>
          <Grid.Column
            style={{
              color: "#fff",
              fontSize: "16px",
              fontWeight: "bold",
              marginLeft: "5px",
              marginTop: "0px",
              paddingTop: "0px",
            }}
          >
            {typeof tags !== "undefined" &&
            tags !== null &&
            tags.length > 0 &&
            tags.findIndex((x) => x.id === tag_id) !== -1
              ? tags[tags.findIndex((x) => x.id === tag_id)].tag_display_name
              : ""}
          </Grid.Column>
        </Grid.Row>
      </Grid>
    ) : (
      ""
    );

  const colorByRange = (tag_id) => {
    let color = "red";
    // color={(typeof data !== 'undefined' && data !== null && data['7828'] === 95) ? 'green' : (data['2993'] === 5 ? 'yellow' : 'red')}
    if (data[tag_id] >= 5 && data[tag_id] < 95) {
      color = "yellow";
    } else if (data[tag_id] >= 95) {
      color = "green";
    } else {
      color = "red";
    }
    return color;
  };

  return (
    <div style={styles.div}>
      <div style={styles.innerdiv}>
        <div style={{ float: "left" }}>
          <div style={styles.menu}>
            <ClearOverride
              tagid={ClearAnIds}
              tags={tags}
              settags={settags}
              option={3}
              title={"CLEAR ALL ANALOG OVERRIDES"}
              channel={"Clear All Analog Overrides"}
              settempovrdata={settempovrdata}
              settempoverriden={settempoverriden}
              parentCallback={parentcallbackAn}
            />
            <ActivateOverride
              ovrdata={anovrdata}
              tags={tags}
              settags={settags}
              option={2}
              title={"ACTIVATE ALL ANALOG OVERRIDES"}
              channel={"Activate All Analog Overrides"}
              parentCallback={parentcallbackAn}
              tempovrdata={tempovrdata}
              settempovrdata={settempovrdata}
              tempoverridden={tempoverridden}
              settempoverriden={settempoverriden}
            />
          </div>
        </div>
        <div style={{ float: "right" }}>
          <div style={styles.menu}>
            <ClearOverride
              tagid={ClearDigIds}
              tags={tags}
              settags={settags}
              option={3}
              title={"CLEAR ALL DIGITAL OVERRIDES"}
              channel={"Clear All Digital Overrides"}
              settempovrdata={settempovrdata}
              settempoverriden={settempoverriden}
              parentCallback={parentcallbackDig}
            />
            <ActivateOverride
              ovrdata={digovrdata}
              tags={tags}
              settags={settags}
              option={2}
              title={"ACTIVATE ALL DIGITAL OVERRIDES"}
              channel={"Activate All Digital Overrides"}
              parentCallback={parentcallbackDig}
              tempovrdata={tempovrdigdata}
              settempovrdata={settempovrdigdata}
              tempoverridden={tempoverridden}
              settempoverriden={settempoverriden}
            />
          </div>
          {/*</Button.Group>*/}
        </div>
        <div style={{ float: "left", marginLeft: "9%" }}>
          <h2 style={styles.header}>{display[0]} </h2>
        </div>
      </div>
      <div style={styles.div}>
        <svg width="2000" height="700">
          <text
            x={390}
            y={410}
            font-size={20}
            fontWeight="bold"
            dominant-baseline="middle"
            text-anchor="middle"
            fill="#0070C0"
          >
            DI WATER
          </text>
          <Valve
            rect={{ x: 736, y: 375 }}
            color={
              typeof data !== "undefined" &&
              data !== null &&
              data["12148"] === 0
                ? "red"
                : "green"
            }
          />{" "}
          {/*CV400*/}
          <Valve
            rect={{ x: 805, y: 375 }}
            color={
              typeof data !== "undefined" &&
              data !== null &&
              data["12151"] === 0
                ? "red"
                : "green"
            }
          />{" "}
          {/*CV401*/}
          <FilterTextVertical rect={{ x: 602, y: 395 }} text={"FLTR400"} />{" "}
          {/* FLTR400 */}
          <path
            d="M 460, 410 L 600, 410"
            stroke="#0070C0"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* DI WATER to FLTR400 */}
          <path
            d="M 683, 410 L 730, 410"
            stroke="#0070C0"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* FLTR400 to CV400 */}
          <path
            d="M 773, 410 L 800, 410"
            stroke="#0070C0"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* CV400 to CV401 */}
          <path
            d="M 840, 410 L 1600, 410 L 1590, 400 L 1590, 410"
            stroke="#0070C0"
            strokeWidth={4}
            fill="none"
          />{" "}
          {/* CV400 to CV401 */}
          <foreignObject x={720} y={425} width={100} height={80}>
            <div style={{ height: "100%" }}>
              {grid_digital_reverse(12148)} {/**CV400 */}
            </div>
          </foreignObject>
          <foreignObject x={790} y={425} width={100} height={80}>
            <div style={{ height: "100%" }}>
              {grid_digital_reverse(12151)} {/**CV401 */}
            </div>
          </foreignObject>
          <foreignObject x={880} y={330} width={100} height={80}>
            <div style={{ height: "100%" }}>
              {grid_analog_reverse(10266)} {/**PT410 */}
            </div>
          </foreignObject>
        </svg>
      </div>
      <Footer tags={FooterTags} data={data} option={"MAIN"} />
    </div>
  );
};

const styles = {
  div: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    flex: "1 1 auto",
    width: "100%",
  },
  toggle: {
    marginLeft: "8px",
    marginTop: "0px",
  },
  grid: {
    marginTop: "5px",
  },
  name: {
    fontSize: "16px",
    fontWeight: "bold",
  },
  unit: {
    color: "#04BFBF",
    fontWeight: "bold",
    fontSize: "16px",
  },
  gridUnit: {
    color: "#04BFBF",
    fontWeight: "bold",
    fontSize: "16px",
    paddingLeft: "3px",
  },
  row: {
    paddingTop: "0px",
    marginBottom: "0px",
    paddingBottom: "0px",
  },
  width: {
    maxWidth: "300px",
  },
  innerdiv: {
    alignItems: "center",
    flex: "1 1 auto",
    paddingBottom: "10px",
    width: "100%",
  },
  menu: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    paddingBottom: "8px",
    paddingLeft: "15px",
    paddingRight: "15px",
  },
  header: {
    marginLeft: "10px",
    marginTop: "10px",
  },
};

const mapDispatchToProps = (dispatch) => {
  return {
    setModel: (model) => dispatch(setModel(model)),
  };
};

const mapStateToProps = (state) => {
  return {
    model: state.header.model,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(React.memo(TMSOvr_S300_MAIN));
